import { render, staticRenderFns } from "./AlgorithmSwitcher.vue?vue&type=template&id=64ddd7b3"
import script from "./AlgorithmSwitcher.vue?vue&type=script&lang=js"
export * from "./AlgorithmSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmSwitcher.vue?vue&type=style&index=0&id=64ddd7b3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports